// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"5b85a6a1","216":"fd5c264b","453":"c0ea28a6","494":"bcb621b0","688":"229f02a2","914":"cfacd060"}[chunkId] + ".chunk.js";
};